module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.jobIsCompleted) ? _c('div', {
    staticClass: "ibox ibox-job-invoice"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs-slim"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-5"
  }, [_c('p', {
    staticClass: "invoice-status",
    class: {
      'text-success': _vm.jobDecorated.invoice.isPaid,
        'text-danger': _vm.jobDecorated.invoice.isOverdue,
        'text-info': _vm.jobDecorated.invoice.isCurrent
    }
  }, [_vm._v("\n            " + _vm._s(_vm.jobDecorated.invoice.status_text) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-lg-3"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "to": {
        name: 'invoices.show',
        params: {
          id: _vm.job.invoice.id
        }
      }
    }
  }, [_vm._v("\n            View "), _c('i', {
    staticClass: "fa fa-angle-right"
  })])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.canSeeJobSetup && !_vm.jobIsPending) ? _c('job-setup') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("\n            Job Overview\n              "), (_vm.job.status != 'pending' && _vm.job.status != 'declined' && _vm.job.status != 'cancelled') ? _c('button', {
    staticClass: "btn btn-info btn-circle pull-right",
    staticStyle: {
      "margin-left": "1rem"
    },
    on: {
      "click": _vm.copyJob
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })]) : _vm._e(), _vm._v(" "), (_vm.canEditJob) ? _c('router-link', {
    staticClass: "btn btn-info btn-circle pull-right",
    attrs: {
      "to": {
        name: 'jobs.edit',
        params: {
          id: _vm.job.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('div', {
    staticClass: "job-overview-details"
  }, [_c('div', {
    staticClass: "row row-clear-sm-6"
  }, [(_vm.canSeeClientInformation) ? [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Client")]), _c('br'), _vm._v("\n                    " + _vm._s(_vm.job.user.profile.full_name) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Company")]), _c('br'), _vm._v("\n                    " + _vm._s(_vm.job.user.profile.company_name) + "\n                  ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Start Date")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.start_at) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("End Date")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.end_at) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Quantity")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.quantity) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Commodity")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.commodity ? _vm.jobDecorated.commodity.name : '–') + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Order")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.order_reference) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Rate")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.rate) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Pickup Reference")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.pickup_reference) + "\n                ")])]), _vm._v(" "), (_vm.distance) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Approximate Distance")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.distance) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Reference")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.delivery_reference) + "\n                ")])]), _vm._v(" "), (_vm.calculation) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('strong', [_vm._v("Calculation")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.calculation) + " cents\n                ")])]) : _vm._e()], 2)]), _vm._v(" "), _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Job Notes")]), _c('br'), _vm._v("\n            " + _vm._s(_vm.jobDecorated.notes) + "\n          ")]), _vm._v(" "), (_vm.$user.isClient) ? _c('notifications') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('div', {
    staticClass: "job-overview-details"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar-assigned",
    style: ({
      width: (_vm.progressAssignedPercentage + "%")
    }),
    attrs: {
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": _vm.progressAssignedPercentage,
      "role": "progressbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progressAssignedPercentage) + "% Assigned")])]), _vm._v(" "), (_vm.progressCompletedPercentage > 0) ? _c('div', {
    staticClass: "progress-bar progress-bar-primary",
    style: ({
      width: (_vm.progressCompletedPercentage + "%")
    }),
    attrs: {
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": _vm.progressCompletedPercentage,
      "role": "progressbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progressCompletedPercentage) + "% Complete")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row row-progress-text"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("\n                " + _vm._s(_vm.tonnageCompleted) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_vm._v("\n                of\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.jobDecorated.quantity) + "\n              ")])]), _vm._v(" "), _c('p', {
    staticClass: "running-total"
  }, [_c('strong', [_vm._v("running total")]), _vm._v(" " + _vm._s(_vm.jobRunningTotal) + "\n            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('div', {
    staticClass: "job-overview-details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('location-detail', {
    attrs: {
      "location": _vm.jobDecorated.location_from,
      "title": "From"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('location-detail', {
    attrs: {
      "location": _vm.jobDecorated.location_to,
      "title": "To"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('distance-map', {
    ref: "map",
    attrs: {
      "location-from": _vm.jobDecorated.location_from,
      "location-to": _vm.jobDecorated.location_to
    }
  })], 1)])])])])]), _vm._v(" "), (_vm.haveJob && !_vm.jobIsPending) ? _c(_vm.loadsComponent, {
    tag: "component"
  }) : _vm._e(), _vm._v(" "), (_vm.canSeeJobHistory) ? _c('history') : _vm._e(), _vm._v(" "), (_vm.canCancelJob) ? _c('ladda-button', {
    staticClass: "btn btn-sm btn-danger pull-right",
    attrs: {
      "on-click": _vm.handleCancelJob
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('location-detail-modal', {
    attrs: {
      "edit": _vm.handleEditLocation
    }
  }), _vm._v(" "), (_vm.editingExistingLocation) ? _c('location-drawer', {
    attrs: {
      "existing-location": _vm.locationBeingEdited,
      "done": _vm.locationDoneCallback,
      "closed": _vm.locationDrawerClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-4"
  }, [_c('h2', [_vm._v("Invoice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Progress")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Locations")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7c87b484"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/Show.vue
// module id = 1054
// module chunks = 0